// Angular 16 no longer runs ngcc for legacy View Engine libraries.
// Keep the JIT compiler available for ng-persian-datepicker, ng2-charts,
// and @ckeditor/ckeditor5-angular until those libraries can be replaced.
import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
